import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
    template: '',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent {
}
